/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       SignupScreenStyle.ts
 * @author     Christian Ascone
 * @date       2/25/20 10:02 AM
 */

import {StyleSheet} from "react-native";

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
    },
    contentContainer: {
        justifyContent: 'space-between',
        paddingTop: 30,
    },
    welcomeContainer: {
        marginTop: 10,
        alignSelf: 'center',
    },
    inputContainer: {
        marginTop: 10,
        marginBottom: 20,
    },
    getStartedContainer: {
        height: '100%',
    },
});

export default styles;